import z from "zod";

export const fiscalAssessmentDocumentGroupsUpdateSchema = z.object({
  documents_attributes: z.array(z.object({
    id: z.string().optional(),
    blob_id: z.string().optional(),
    // file_attachment_attributes: z.object({
    //   id: z.string().optional(),
    //   file: z.custom<File | string>().optional(),
    // }),
  })),
});

export type FiscalAssessmentDocumentGroupsUpdateValidationSchema = z.infer<typeof fiscalAssessmentDocumentGroupsUpdateSchema>;
